import { useRegion } from "../context/RegionContext";
import ProjectInquiryForm from "../components/forms/ProjectInquiryForm";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import Seo from "../components/Seo";

export default function DiscussProject() {
  const { config } = useRegion();
  return (
    <div data-testid="discuss-project-page">
      <Seo
        path="/contact"
        title="Contact Us"
        description="Get in touch with Andrea Kanaris. All Things Social Impact - practitioner-led advisory across AU and US. Submissions reviewed personally within two business days."
      />
      <section className="bg-brand-blue text-white py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="eyebrow text-brand-yellow mb-6">Contact Us</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">Get in touch with Andrea.</h1>
          <p className="text-lg lg:text-xl text-white/80 max-w-3xl mt-6 leading-relaxed">A short inquiry gives us enough context to come back with a considered response - usually within two business days. All submissions are reviewed personally by Andrea.</p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="bg-white border border-slate-200 p-8 sticky top-28">
              <div className="eyebrow mb-4">{config.label} contact</div>
              <div className="space-y-5 mt-4">
                <div className="flex items-start gap-3"><Mail className="w-5 h-5 text-brand-orange mt-0.5" /><div><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Email</div><div className="text-slate-800 text-sm">{config.email}</div></div></div>
                <div className="flex items-start gap-3"><Phone className="w-5 h-5 text-brand-orange mt-0.5" /><div><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Phone</div><div className="text-slate-800 text-sm">{config.phone}</div></div></div>
                <div className="flex items-start gap-3"><MapPin className="w-5 h-5 text-brand-orange mt-0.5" /><div><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Based in</div><div className="text-slate-800 text-sm">{config.address}</div></div></div>
                <div className="flex items-start gap-3"><Clock className="w-5 h-5 text-brand-orange mt-0.5" /><div><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Response</div><div className="text-slate-800 text-sm">Within two business days</div></div></div>
              </div>
              <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-500 leading-relaxed">
                <div className="font-semibold text-slate-700 mb-1">Legal entity</div>
                {config.entity}
              </div>
            </div>
          </div>
          <div className="lg:col-span-8">
            <ProjectInquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}
